import { ButtonBase } from '@mui/material';
import { Box } from '@mui/system';
import React, { ComponentType, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'src/common/theme/theme';
import { EyeAltIcon } from 'src/components/icons/icons';
import useStyles from './styles';

export const A11yBtn: ComponentType = () => {
  const classes = useStyles();
  const { currentTheme, setTheme } = useContext(ThemeContext);
  const { t } = useTranslation();

  const onChangeTheme = () => {
    setTheme && setTheme(currentTheme === 'light' ? 'a11y' : 'light');
  };

  return (
    <Box className={classes.root}>
      <ButtonBase
        color="secondary"
        aria-label={t('visuallyImpaired', 'Версия для слабовидящих')}
        title={t('visuallyImpaired', 'Версия для слабовидящих')}
        onClick={onChangeTheme}
      >
        <EyeAltIcon />
      </ButtonBase>
    </Box>
  );
};
